import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hadrian-arbitrary-tooltip" }
const _hoisted_2 = { class: "hadrian-arbitrary-tooltip__tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "wrapped-element", {}, undefined, true),
    (_ctx.enabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["hadrian-arbitrary-tooltip__tooltip-outer", _ctx.tooltipOuterClasses])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "content", {}, undefined, true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}